import React from 'react';
import { Heart, Users, Zap, Target } from 'lucide-react';

const About = () => {
  const values = [
    {
      icon: <Heart className="w-8 h-8" />,
      title: "User-Centric Design",
      description: "Every device is designed with comfort, functionality, and personal expression in mind."
    },
    {
      icon: <Users className="w-8 h-8" />,
      title: "Accessibility First",
      description: "Decentralized labs make custom prosthetics affordable and accessible to all communities."
    },
    {
      icon: <Zap className="w-8 h-8" />,
      title: "Advanced Technology",
      description: "Smart sensing and 3D printing deliver unmatched comfort and precision."
    },
    {
      icon: <Target className="w-8 h-8" />,
      title: "Local Production",
      description: "Clinic-based manufacturing reduces costs and delivery times significantly."
    }
  ];

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left - Image */}
          <div className="relative">
            <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://customer-assets.emergentagent.com/job_access-limbs/artifacts/w3c0egkx_WhatsApp%20Image%202025-11-01%20at%2020.21.43.jpeg"
                alt="3D Printed Prosthetic Socket"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -top-6 -left-6 w-32 h-32 bg-gradient-to-br from-purple-400 to-blue-400 rounded-full opacity-20 blur-2xl"></div>
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-gradient-to-br from-amber-400 to-purple-400 rounded-full opacity-20 blur-2xl"></div>
          </div>

          {/* Right - Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
                Revolutionizing
                <span className="block bg-gradient-to-r from-purple-600 to-blue-500 bg-clip-text text-transparent">
                  Prosthetic & Orthotic Care
                </span>
              </h2>
              <p className="text-lg text-gray-600 leading-relaxed">
                By decentralizing 3D fabrication labs into local clinics, we bring manufacturing closer to the user—reducing cost, lead time, and dependency on imported systems. Our technology blends advanced scanning, adaptive sensing, and user-centric design to deliver comfort and performance at a personal level.
              </p>
              <p className="text-lg text-gray-600 leading-relaxed">
                At HyBionics, we merge engineering excellence with human empathy—transforming prosthetic care from a one-size-fits-all approach into a connected, customizable experience. Our mission is simple yet powerful: to make mobility smarter, prosthetics more human, and innovation truly inclusive.
              </p>
            </div>

            {/* Values Grid */}
            <div className="grid sm:grid-cols-2 gap-6 pt-6">
              {values.map((value, index) => (
                <div
                  key={index}
                  className="p-6 rounded-xl bg-gradient-to-br from-purple-50 to-blue-50 hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1 group"
                >
                  <div className="text-purple-600 mb-3 group-hover:scale-110 transition-transform duration-300">
                    {value.icon}
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">{value.title}</h3>
                  <p className="text-sm text-gray-600">{value.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;